import { Icone, type NomeIcone } from '../icones';
import { ORDEM_PREFERENCIA, ROTULO_PREFERENCIA, definirPreferencia, preferencia, type Preferencia } from '../tema';

const ICONE: Record<Preferencia, NomeIcone> = { sistema: 'monitor', claro: 'sol', escuro: 'lua' };

/** Botão único que alterna Automático → Claro → Escuro. Cabe em qualquer barra (login, menu do computador). */
export function BotaoTema({ class: classe = '' }: { class?: string }) {
  const atual = preferencia.value;
  const proxima = ORDEM_PREFERENCIA[(ORDEM_PREFERENCIA.indexOf(atual) + 1) % ORDEM_PREFERENCIA.length]!;
  return (
    <button
      type="button"
      class={`botao-tema ${classe}`.trim()}
      onClick={() => definirPreferencia(proxima)}
      title={`Tema: ${ROTULO_PREFERENCIA[atual]}. Clique para mudar para ${ROTULO_PREFERENCIA[proxima]}.`}
      aria-label={`Tema: ${ROTULO_PREFERENCIA[atual]}. Mudar para ${ROTULO_PREFERENCIA[proxima]}.`}
    >
      <Icone nome={ICONE[atual]} />
    </button>
  );
}

/** As três opções à vista (usado na janela "Mais" do celular). */
export function SeletorTema() {
  const atual = preferencia.value;
  return (
    <div class="seletor-tema" role="radiogroup" aria-label="Tema da tela">
      {ORDEM_PREFERENCIA.map((p) => (
        <button key={p} type="button" role="radio" aria-checked={atual === p} class={atual === p ? 'ativo' : ''} onClick={() => definirPreferencia(p)}>
          <Icone nome={ICONE[p]} tamanho={18} />
          {ROTULO_PREFERENCIA[p]}
        </button>
      ))}
    </div>
  );
}
